export const SharedDashboardSettings = {
    state: {
        isDarkMode: false,
        isFullScreen: false,
    },
    getters: {
        GET_DARK_MODE (state){
            return state.isDarkMode;
        },
        GET_IS_DASHBOARD_FULL_SCREEN (state){
            return state.isFullScreen;
        },
    },
    mutations: {
        SET_DARK_MODE (state, value){
            state.isDarkMode = value;
        },
        SET_IS_DASHBOARD_FULL_SCREEN (state, value){
            state.isFullScreen = value;
        },
    },
    actions: {
        TOGGLE_DASHBOARD_FULL_SCREEN ({commit, getters}){
            commit('SET_IS_DASHBOARD_FULL_SCREEN', !getters.GET_IS_DASHBOARD_FULL_SCREEN);
        }
    }
}